// extracted by mini-css-extract-plugin
module.exports = {"footer":"__47Vz5lte","chrismas":"c3yYaJ3o"};